import React from "react";
import StyleWrapper from "components/Global/Modal/Layout/StyleWrapper";
import {
  ButtonRed,
  ButtonOutline,
  ButtonGroup,
  ButtonOrange
} from "components/Global/Modal/Layout/Buttons";

import { connect } from "react-redux";
import { hideModal } from "redux/modules/modal/actions";

const decorate = connect(null, {
  hideModal
});

const DeleteConfirmationModal = ({
  heading,
  hideModal,
  message,
  onConfirm,
  confirmLabel,
  width = 415,
  orangeButton = false,
  zIndex = undefined,
  cancelLabel = undefined,
  onCancel = undefined,
  hideHeader = false
}) => (
  <StyleWrapper
    {...(zIndex !== undefined ? { zIndex } : {})}
    background={"red"}
    width={width}
    heading={heading}
    hideModal={hideModal}
    hideHeader={hideHeader}
  >
    {message}
    <ButtonGroup style={{ marginTop: "16px" }}>
      {orangeButton ? (
        <ButtonOrange
          onClick={() => {
            onConfirm();
            hideModal();
          }}
          title={confirmLabel}
        />
      ) : (
        <ButtonRed
          onClick={() => {
            onConfirm();
            hideModal();
          }}
          title={confirmLabel}
        />
      )}
      <ButtonOutline
        style={{ color: "#494949" }}
        onClick={() => {
          hideModal();
          if (onCancel) onCancel();
        }}
        title={cancelLabel || "Cancel"}
      />
    </ButtonGroup>
  </StyleWrapper>
);

DeleteConfirmationModal.defaultProps = {
  confirmLabel: "Delete"
};

export default decorate(DeleteConfirmationModal);
